import React, { useState, useEffect } from "react";
import Select from "react-dropdown-select";
import "react-datepicker/dist/react-datepicker.css";
import { ActivityPopup } from "../../ReusableComponents/ActivityPopup";
import Cookies from "universal-cookie";
import { getGCSDrones, getGCSFlightPilots } from "../../api";
import DatePickerDateOnly from "../Components/FlightsFilter/DatePicker";

const ReportsFilter = ({
    selectedTab,
    isPilotEnable,
    selectedDrone,
    defaultFromDateTime,
    defaultToDateTime,
    selectedPilot,
    stats,
    cookiesData,
    statsSecondRow,
    onFilterDataChange,
    onChangeCheckbox,
    reportType
}) => {
    const cookies = new Cookies()

    const [firstTime, setFirstTime] = useState(false)

    const [pilotsOptions, setPilotsOptions] = useState([])
    const [dronesOptions, setDronesOptions] = useState([])
    const pageData = cookies.get("page_data")
    const [filters, setFilters] = useState({
        fromDateTime: null,
        toDateTime: null,
        selectedDrones: [],
        selectedPilots: [],
        selectedTab: selectedTab || null,
        pageNumber: cookiesData || 1,
    });
    const [toggleChecked, setToggleChecked] = useState(false);

    const buttonOptions = [
        { id: 3, placeholder: "Daily" },
        { id: 4, placeholder: "Weekly" },
        { id: 6, placeholder: "Monthly" },
        { id: 1, placeholder: "Yearly" },
        { id: 2, placeholder: "Custom" },
    ];

    // State for datepicker open/close
    const [openDatepicker, setOpenDatepicker] = useState({
        fromdatePicker: false,
        todatePicker: false,
    });

    // State for from/to dates
    const [fromDateTime, setFromDateTime] = useState(null);
    const [toDateTime, setToDateTime] = useState(null);

    const initData = async () => {
        setFirstTime(true)
            ;
        try {
            const dataKey = pageData ? pageData['acres']
                ? 'acres'
                : pageData['flights']
                    ? 'flights'
                    : 'pilots' : null;
            if (isPilotEnable) {
                const pilots = await getGCSFlightPilots({ orderType: "ASC" })
                setPilotsOptions(pilots)
                if (selectedPilot) {
                    const pilot = pilots.find(p => p.pilot_id === selectedPilot.value)
                    if (pilot) setFilters(prev => ({
                        ...prev,
                        selectedPilots: [{
                            value: pilot.pilot_id,
                            label: pilot.pilot_name
                        }],
                        pageNumber: pageData[dataKey]?.selectedPilot == pilot?.pilot_name ? pageData[dataKey]?.pageNumber : 1
                    }))
                }
            }
            const drones = (await getGCSDrones()).drones
            if (selectedDrone) {
                const drone = drones.find(drone => selectedDrone === drone.drone_id || selectedDrone.value === drone.drone_id)
                if (drone) setFilters(prev => ({
                    ...prev,
                    selectedDrones: [{
                        value: drone.drone_id,
                        label: `${drone.uin} (${drone.drone_name})`
                    }],
                    pageNumber: dataKey ? pageData[dataKey]?.selectedDrone === `${drone.uin} (${drone.drone_name})`
                        ? pageData[dataKey]?.pageNumber
                        : 1 : 1


                }))
            }
            setDronesOptions(drones)
        } catch (e) {
            console.error(e.message)
        }
    }
    useEffect(() => {
        initData()
    }, [])

    useEffect(() => {
        if (selectedTab && filters.selectedTab !== selectedTab) {
            setFilters(prev => ({
                ...prev,
                selectedTab,
                ...(selectedTab !== "Custom" && { fromDateTime: null, toDateTime: null })
            }));
        }
    }, [selectedTab]);

    useEffect(() => {
        onChangeCheckbox(toggleChecked)
    }, [toggleChecked])

    // Helper to calculate days between two dates
    const getDaysDiff = (from, to) => {
        if (!from || !to) return 0;
        const diff = Math.abs(new Date(to).setHours(0, 0, 0, 0) - new Date(from).setHours(0, 0, 0, 0));
        return Math.ceil(diff / (1000 * 60 * 60 * 24)) + 1;
    };

    // Handle date changes and tab switching
    const handleFilterChange = (key, value) => {
        setFilters(prev => {
            const updated = { ...prev };
            if (key === "fromDateTime") updated.fromDateTime = value;
            if (key === "toDateTime") updated.toDateTime = value;
            updated.selectedTab = "Custom";
            return updated;
        });
    };

    useEffect(() => {
        if (onFilterDataChange) {
            onFilterDataChange({ ...filters, firstTime });
        }
    }, [filters]);

    return <>
        <ActivityPopup
            item={null}
            open={false}
            icon={null}
            action={null}
            msg={''}
            close={() => { }}
            onClickOk={() => { }}
        />
        <div className="" style={{ padding: "18px 30px", background: "#FCFCFC", borderRadius: "10px 10px 0px 0px", marginTop: "15px", marginBottom: "15px" }} >

            <div className="first_section">
                <div style={{ width: '70%' }}>
                    <div className="stats">
                        {stats && Object.keys(stats).map((statKey, index) => (
                            <>
                                {index > 0 && <div className="separator"></div>}
                                <div className="stat_card">
                                    <span>{statKey}</span>
                                    <p>{stats[statKey]}</p>
                                </div>
                            </>
                        ))}

                        {reportType != 'Maintenance Drones' && <>
                            <div style={{ height: "20px", width: "1px", backgroundColor: "#d1d5db", }}></div>
                            <input type="checkbox" id="customSwitches" checked={toggleChecked}
                                onChange={() => setToggleChecked(!toggleChecked)}
                                style={{ width: "18px", height: "18px", accentColor: "#2563eb", cursor: "pointer", }}
                            />
                            <label htmlFor="customSwitches" style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "0px" }}>Include Inactive Drones</label>
                        </>}
                    </div>
                    <div className="stats">
                        {statsSecondRow && Object.keys(statsSecondRow).map((statKey, index) => (
                            <>
                                {index > 0 && <div className="separator"></div>}
                                <div className="stat_card">
                                    <span>{statKey}</span>
                                    <p>{statsSecondRow[statKey]}</p>
                                </div>
                            </>
                        ))}


                    </div>


                </div>
                <div style={{}} className="duration_selectors">
                    {buttonOptions.map((button, i) => (
                        <button
                            key={button.id}
                            style={{
                                borderLeft: i === 0 && filters.selectedTab !== button.placeholder && "1px solid #C9C9C9",
                                borderRight: filters.selectedTab !== button.placeholder && "1px solid #C9C9C9",
                            }}
                            className={filters.selectedTab === button.placeholder ? "active" : ""}
                            onClick={() => {
                                setFilters(prev => ({
                                    ...prev,
                                    selectedTab: button.placeholder,
                                    ...(button.placeholder !== "Custom" && { fromDateTime: null, toDateTime: null })
                                }));
                            }}
                        >
                            {button.placeholder}
                        </button>
                    ))}
                </div>
            </div>
            <div className="second__section" style={{ marginTop: "20px" }}>
                <div className="Drones__Pilots__select">
                    {isPilotEnable &&
                        <div className="pilots_wrapper">
                            <span className="select_dropdown_label">Select Pilot</span>
                            <div title={filters.selectedPilots[0]?.label?.length > 32 && filters.selectedPilots[0]?.label}>
                                <Select
                                    style={{ width: "230px" }}
                                    placeholder="Search..."
                                    options={pilotsOptions?.map(pilot => ({
                                        label: pilot.pilot_name || '',
                                        value: pilot.pilot_id || ''
                                    }))}
                                    values={filters.selectedPilots}
                                    className="custom_dropdown"
                                    onChange={selected => {
                                        setFilters(prev => ({
                                            ...prev,
                                            selectedPilots: selected
                                        }));
                                    }}
                                />
                            </div>
                        </div>
                    }
                    <div className="pilots_wrapper">
                        <span className="select_dropdown_label">Select Drone</span>
                        <div title={filters.selectedDrones[0]?.label?.length > 32 && filters.selectedDrones[0]?.label}>
                            <Select
                                placeholder="Search..."
                                style={{ width: "330px" }}
                                options={dronesOptions?.map(drone => ({
                                    label: `${drone.uin} (${drone.drone_name})`,
                                    value: drone.drone_id,
                                }))}
                                searchBy={"label"}
                                values={filters.selectedDrones}
                                className="custom_dropdown"
                                onChange={selected => {
                                    setFilters(prev => ({
                                        ...prev,
                                        selectedDrones: selected
                                    }));
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="dates__section">
                    <span>Select Duration</span>
                    <DatePickerDateOnly
                        fromdatePicker={openDatepicker.fromdatePicker}
                        todatePicker={openDatepicker.todatePicker}
                        fromDateTime={filters.fromDateTime ?? defaultFromDateTime}
                        toDateTime={filters.toDateTime ?? defaultToDateTime}
                        setOpenDatepicker={setOpenDatepicker}
                        handleFilterChange={handleFilterChange}
                        isDisabled={false}
                    />
                </div>




            </div>
        </div >
    </>;
};

export default ReportsFilter;
